/*
 * This file is generated by the workex CLI Tool
 *
 * Please visit https://workex.pistonite.dev for more information
 */

import type { PrismApi } from "../proto.ts";

import type { WxPromise, WxBusRecvHandler, WxProtocolBoundSender } from "@pistonite/workex";
import type { PrismOutput } from "../pkg/prism_wasm";

/*
 * These generated implementations are used internally by other generated code.
 * They should not be used directly!
 */

/**
 * Prism WASM API
 */
export class _wxSenderImpl implements PrismApi {
    private sender: WxProtocolBoundSender

    constructor(sender: WxProtocolBoundSender) {
        this.sender = sender
    }

    /**
     * run rendering script
     */
    public runScript( script: string, forceSquare: boolean ): WxPromise<PrismOutput> {
        return this.sender.send<PrismOutput>(16 /* PrismApi.runScript */, [ script, forceSquare ]);
    }
}

/**
 * Prism WASM API
 */
export const _wxRecverImpl = (handler: PrismApi): WxBusRecvHandler => {
    return ((fId, args: any[]) => { switch (fId) {
        case 16 /* PrismApi.runScript */: {
            const [ a0, a1 ] = args;
            return handler.runScript( a0, a1 );
        }
    } return Promise.resolve({ err: { code: "UnknownFunction" } }); }) as WxBusRecvHandler;
};